import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { DetalheAnimal } from "../typings";
import http from 'infra/http';

export function useDetalhesAnimal(id?: string) {
  return useQuery<DetalheAnimal, AxiosError>(
    `/v1/animal/${id}`,
    async () => {
      const { data } = await http.get<DetalheAnimal>(`/v1/animal/${id}`);

      return data;
    },
    {enabled: !!id},
  );
}